import { render, staticRenderFns } from "./DashboardNavbarApps.vue?vue&type=template&id=5b25c7c8"
import script from "./DashboardNavbarApps.vue?vue&type=script&lang=js"
export * from "./DashboardNavbarApps.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports